import styled from "styled-components";
import { Trash, Plus, DotsNine } from "phosphor-react";
import Item from "./CategoryItem";
import { Draggable } from "react-beautiful-dnd";
import { useFirestore } from "react-redux-firebase";
import { v4 } from "uuid";

const Container = styled.div`
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  margin: 20px 0;
  border-radius: 3px;

  border: 2px solid
    ${({ isDragging, color }) => (isDragging ? "lightblue" : color)};
  position: relative;
  background: transparent;
`;

const DataContainer = styled.div`
  padding: 10px;
`;

const TitleInput = styled.input`
  border: none;
  color: ${({ color }) => color};
  padding-top: 5px;
  border-radius: 0 !important;
  width: 50%;
  font-weight: 900;
  background: transparent;
  font-size: 1rem;

  &:focus {
    outline: none;
  }
`;

const TrashIcon = styled.div`
  color: #798b79;
  cursor: pointer;
  border: 1px solid transparent;
  padding: 5px;
  &:hover {
    border-bottom: 1px solid #798b79;
  }

  border-radius: 0px !important;
`;

const Buttons = styled.div`
  position: absolute;
  display: flex;
  right: 0;
  top: 0;
`;

const AddItem = styled.div`
  display: flex;
  border: 1px solid grey;
  align-items: center;
  color: grey;
  padding: 3px;
  cursor: pointer;
  width: max-content;
  border-radius: 3px;
  margin-bottom: 10px;
  &:hover {
    background: grey;
    color: white;
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`;

const Handle = styled.div`
  color: #798b79;
`;

const Category = ({
  kit,
  item,
  categoryIndex,
  deleteItem,
  deleteCategoryItem,
  handleCategoryItemTax,
  kitIndex,
  addItem,
  editCategoryItem,
  doc,
  storedDocuments,
  setStoredDocuments,
  color,
  prices,
}) => {
  const firestore = useFirestore();

  const addItemToCategory = (categoryIndex) => {
    let docs = [...storedDocuments];

    docs[docs.indexOf(doc)].kits[kitIndex].items[categoryIndex].category.push({
      title: "",
      amount: 0,
      tax: true,
      id: v4(),
    });
    setStoredDocuments(docs);
    return firestore.update(
      { collection: "client-documents", doc: doc.id },
      docs[docs.indexOf(doc)]
    );
  };

  const editCategory = (name, value, kitIndex, itemIndex) => {
    let docs = [...storedDocuments];
    docs[docs.indexOf(doc)].kits[kitIndex].items[itemIndex][name] = value;
    setStoredDocuments(docs);
    return firestore.update(
      { collection: "client-documents", doc: doc.id },
      docs[docs.indexOf(doc)]
    );
  };

  const deleteCategory = (kitIndex, itemIndex) => {
    let docs = [...storedDocuments];
    docs[docs.indexOf(doc)].kits[kitIndex].items.splice(itemIndex, 1);
    setStoredDocuments(docs);
    return firestore.update(
      { collection: "client-documents", doc: doc.id },
      docs[docs.indexOf(doc)]
    );
  };

  const handleEdit = (id, value, i, k) => {
    editCategoryItem(categoryIndex, id, value, i, k);
  };
  const handleDelete = (yurtIndex, itemIndex) => {
    deleteCategoryItem(yurtIndex, categoryIndex, itemIndex);
  };
  const setTax = (yurtIndex, itemIndex) => {
    handleCategoryItemTax(yurtIndex, categoryIndex, itemIndex);
  };

  return (
    <Draggable
      draggableId={item.title + categoryIndex + kit.id}
      index={categoryIndex}
    >
      {(provided, snapshot) => (
        <Container
          {...provided.draggableProps}
          innerRef={provided.innerRef}
          ref={provided.innerRef}
          key={item.title + item.amount + kit.id + categoryIndex}
          isDragging={snapshot.isDragging}
          color={color}
        >
          <DataContainer>
            <TitleInput
              autoComplete="off"
              name="title"
              onBlur={(e) =>
                editCategory(
                  e.target.name,
                  e.target.value,
                  kitIndex,
                  categoryIndex
                )
              }
              defaultValue={item.title}
              color={color}
            ></TitleInput>
            <Buttons>
              <TrashIcon
                onClick={() => deleteCategory(kitIndex, categoryIndex)}
              >
                <Trash />
              </TrashIcon>
            </Buttons>
            {item.category.map((subItem, k) => (
              <Item
                key={k}
                item={subItem}
                index={k}
                yurt={kit}
                deleteItem={handleDelete}
                handleTax={setTax}
                addItem={addItem}
                editItem={handleEdit}
                yurtIndex={kitIndex}
                categorySnapshot={snapshot}
                categoryIndex={categoryIndex}
                storedDocuments={storedDocuments}
                doc={doc}
                setStoredDocuments={setStoredDocuments}
                color={color}
                prices={prices}
                kit={kit}
              />
            ))}
            <Footer>
              <AddItem onClick={() => addItemToCategory(categoryIndex)}>
                <Plus />
              </AddItem>
              <Handle {...provided.dragHandleProps}>
                <DotsNine size={25} weight="bold" />
              </Handle>
            </Footer>
          </DataContainer>
        </Container>
      )}
    </Draggable>
  );
};

export default Category;
